import './CardForm.scss';
import { useTranslation } from "react-i18next";

const win: any = window;

interface Props {
    shoppingCart: any;
    rtl: boolean;
}

function CardForm({ shoppingCart, rtl }: Props) {
    const { t } = useTranslation();

    const handlePay = () => {
        win['pay']();
        win.MixpanelTracker.trackEvent("Payment Initiated", {  payment_method: "Card"});
    }

    const cartTotalPrice = shoppingCart && shoppingCart.cartTotalPrice.filter((cart: any) => cart.priceType === "Onetime")[0]

    return (
        <>
            <form name="control-ref">
                <div className={rtl ? 'Payment__FormSection Payment_arabic' : 'Payment__FormSection'}>
                    <div className='FormInput_Control'>
                        <div className='input-labels'>{t("cnHeading")}</div>
                        <input type="text" id="card-number" placeholder='XXXX XXXX XXXX XXXX' className="input__field" title="card number" aria-label="enter your card number" value="" tabIndex={1} readOnly />
                        <small className='cNumberError'>&nbsp;</small>
                    </div>
                    <div className='Payment__month-year'>
                        <div className='FormInput_Control'>
                            <div className='input-labels'>{t("ExpiryMonth")}</div>
                            <input type="text" id="expiry-month" placeholder='XX' className="input__field expirationMM__inputField" title="expiry month" aria-label="two digit expiry month" value="" tabIndex={2} readOnly />
                            <small className='expiryMonthError'>&nbsp;</small>
                        </div>
                        <div className='FormInput_Control'>
                            <div className='input-labels'>{t("ExpiryYear")}</div>
                            <input type="text" id="expiry-year" placeholder='XX' className="input__field expirationYY__inputField" title="expiry year" aria-label="two digit expiry year" value="" tabIndex={3} readOnly />
                            <small className='expiryYearError'>&nbsp;</small>
                        </div>
                    </div>
                    <div className='FormInput_Control'>
                        <div className='input-labels'>{t("secHeading")}</div>
                        <input type="text" id="security-code" placeholder='XXX' className="input__field" title="security code" aria-label="three digit CCV security code" value="" tabIndex={4} readOnly />
                        <small className='cvvError'>&nbsp;</small>
                    </div>
                </div>
                <div className='Payment__amount'>
                    <div className='typography'>{t("TotalAmount")}:  <span>{cartTotalPrice && cartTotalPrice.price.taxIncludedAlteredAmount.value} {cartTotalPrice && cartTotalPrice.price.taxIncludedAlteredAmount.unit}</span></div>
                </div>

                <div className='Payment__payButton'>
                    <button id="pay-enable" className={'button'} type={'button'} tabIndex={5} onClick={() => handlePay()}>{t("PayNow")}</button>
                    <button id="pay-disable" disabled={true} className={'disable-button button'} type={'button'} tabIndex={6}>{t("PayNow")}</button>
                </div>
            </form>
        </>
    )
}

export default CardForm;
